"use strict";
/*
 * Created on 19. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ReleaseActionResultConverter_1 = require("./ReleaseActionResultConverter");

var ReleasePartActionResultConverter_1 = require("./ReleasePartActionResultConverter");
/**
 * @author Radek Beran
 */


var ReleaseActionResultConverterImpl =
/*#__PURE__*/
function (_ReleaseActionResultC) {
  _inherits(ReleaseActionResultConverterImpl, _ReleaseActionResultC);

  function ReleaseActionResultConverterImpl(releasePartActionResultConverter) {
    var _this;

    _classCallCheck(this, ReleaseActionResultConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseActionResultConverterImpl).call(this));
    _this.releasePartActionResultConverter = releasePartActionResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ReleaseActionResultConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      throw new Error('Not implemented because it is not needed.');
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        successAll: source.successAll
      });
      Object.assign(result, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId)
      });
      Object.assign(result, {
        action: source.action.toString()
      }); // calling toString on string type enum is not needed

      Object.assign(result, {
        results: conversions.asObjectArray(source, 'results', function (actionResult) {
          return _this2.releasePartActionResultConverter.toDocument(actionResult, conversions);
        })
      });
      return result;
    }
  }]);

  return ReleaseActionResultConverterImpl;
}(ReleaseActionResultConverter_1.ReleaseActionResultConverter);

ReleaseActionResultConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ReleasePartActionResultConverter_1.ReleasePartActionResultConverter])], ReleaseActionResultConverterImpl);
exports.ReleaseActionResultConverterImpl = ReleaseActionResultConverterImpl;